<template>
  <div>
    <v-dialog v-model="showLookup" width="900" persistent>
      <v-card class="pb-4">
        <v-card-title class="primary">
          <span class="white--text">Address Lookup</span>
        </v-card-title>
        <v-card-text class="subtitle-1 pb-0">
          <app-table :items="addresses" :headers="headers" class="mt-6"></app-table>
        </v-card-text>

        <v-card-actions class="mt-4">
          <v-spacer></v-spacer>
          <v-btn @click="close" class="mr-4">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AddressDialog",
  data: () => ({
    showLookup: false,
    locId: "",
    addresses: [],
    headers: [
      {
        text: "",
        sortable: false,
        value: "icon"
      },
      {
        text: "Location ID",
        sortable: false,
        value: "locationId"
      },
      {
        text: "Address",
        sortable: false,
        value: "formattedAddress"
      }
    ]
  }),
  methods: {
    queryAddress(data){
      let vm = this;
      let stateOrProvince = "";
      let postcode = "";
      let suburb = "";
      let streetName = "";
      let streetType = "";
      let streetNrFirst = "";

      data.forEach(x => {
        switch (x.name) {
          case "stateOrProvince":
            stateOrProvince = x.value
            break;
          case "postcode":
            postcode = x.value
            break;
          case "suburb":
            suburb = x.value
            break;
          case "streetName":
            streetName = x.value
            break;
          case "streetType":
            streetType = x.value
            break;
          case "streetNrFirst":
            streetNrFirst = x.value
            break;
        }
      })
      
      let payload = {
        addressCheckServiceType: "NBN",
        addressCheckMethodType: "PHYSICAL_ADDRESS",
        address: {
          StateOrProvince: stateOrProvince,
          Postcode: postcode,
          Suburb: suburb,
          StreetName: streetName,
          StreetType: streetType,
          StreetNrFirst: streetNrFirst
        }
      };

      vm.addressQuery(payload).then(result => {
        result.addresses.forEach(x => {
          let location = "";
          let formatted = "";
          let match = false;

          x.forEach(y => {
            if(y.name === "locationId"){
              location = y.value;
              if(y.value === vm.locId) match = true;
            }
            else if(y.name === "formattedAddress") formatted = y.value;
          });

          vm.addresses.push({
            locationId: location,
            formattedAddress: formatted,
            icon: match ? 'mdi-checkbox-marked-circle' : ''
          })
        });
        vm.showLookup = true;
      });
    },
    close() {
      let vm = this;
      vm.showLookup = false;
      vm.addresses = [];
      vm.locId = "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
